import { SessionStorageKeys } from '@aglenergy/shared-library';
import { store } from 'app/shared/store/store';
import { mobileProductService } from 'app/mobile/services/mobile-product/mobile-product.service';
import { ProductsResponse } from 'app/shared/models/product-response.model';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { bannerService } from 'app/shared/services/banner/banner.service';
import { customerProfileService } from 'app/shared/services/customer-profile/customerProfile-service';
import { flowService } from 'app/shared/services/flow/flow-service';
import { tealiumAnalyticService } from 'app/shared/services/tealium/tealium-analytics.service';
import { setPromoInStore } from 'app/shared/utilities/promo.util';
import { removeHandler } from 'app/shared/store/handlers/types/remove-handler';
import { customerProfileHandler } from 'app/mobile/store/handlers/customerProfile.handler';

const registeredHandlers = (): removeHandler => {
  const removeTelcoAccountHandler = customerProfileHandler(store);
  return () => {
    removeTelcoAccountHandler();
  };
};

export const onStoreInit = async (isGuidedFlow: boolean): Promise<void> => {
  if (!isGuidedFlow && sessionStorage.getItem(SessionStorageKeys.FlowDetails) && flowService.getFlowDetails()?.flowType === 'guided-flow') {
    sessionStorage.removeItem(SessionStorageKeys.FlowDetails);
    sessionStorage.removeItem(SessionStorageKeys.PageHistory);
  }
  store.set(StoreKeys.responseError, null);
  tealiumAnalyticService.trackProductCards([], true, 'mobile plan');

  const selectedProduct = JSON.parse(sessionStorage.getItem(SessionStorageKeys.SelectedMobileProductDetails));
  if (selectedProduct) {
    store.set('selectedMobileProductDetails', selectedProduct);
  }

  registeredHandlers();
  const customerProfile = customerProfileService.getCustomerProfile();
  store.set('customerProfile', customerProfile);

  await mobileProductService
    .getProducts()
    .then((productDetails: ProductsResponse) => {
      setPromoInStore(productDetails);
      store.set(StoreKeys.productDetails, productDetails);

      store.set(StoreKeys.responseError, null);
      bannerService.toggleBanner();
    })
    .catch((error) => {
      store.set(StoreKeys.responseError, error);
    })
    .finally(() => {
      store.set('isPageLoaded', true);
    });
};
